
<div class="container">
    <mat-toolbar>
        <span>My Application</span>
      </mat-toolbar>
      <p>
        Para efectuar sus pagos a Autogalias, por favor ingrese sus datos de identificación o de la persona a nombre de quien están las obligaciones
      <p>    
</div>
